<template>
    <div class="main-start__container">
        <h2>{{ $t("lang.pages.common.blocks.mainStart.title") }}</h2>
        <div class="main-start__content">
            <div class="main-start__item">
                <div><i class="pi pi-info text-3xl"></i></div>
                <span>{{ $t("lang.pages.common.blocks.mainStart.helpTitle") }}</span>
                <p>{{ $t("lang.pages.common.blocks.mainStart.helpDescription") }}</p>
                <a href="https://help.keys.so/" class="main-start__link">
                    {{ $t("lang.pages.common.blocks.mainStart.helpButton") }}
                </a>
            </div>
            <div class="main-start__item">
                <div><i class="pi pi-book text-3xl"></i></div>
                <span>{{ $t("lang.pages.common.blocks.mainStart.socTitle") }}</span>
                <p>{{ $t("lang.pages.common.blocks.mainStart.socDescription") }}</p>
                <div class="main-start__icons">
                    <a href="https://t.me/keysso_public" target="_blank">
                        <img :src="getIconUrl('tg.svg')" alt="telegram" />
                    </a>
                    <a href="https://vk.com/keys_so" target="_blank">
                        <img :src="getIconUrl('vk.svg')" alt="vk" />
                    </a>
                    <a href="https://www.youtube.com/channel/UCQXBMzcU11p-6CRRpX0phxg" target="_blank">
                        <img :src="getIconUrl('youtube.svg')" alt="youtube" />
                    </a>
                    <a href="https://rutube.ru/channel/38416987" target="_blank">
                        <img :src="getIconUrl('rutube.svg')" alt="rutube" />
                    </a>
                </div>
            </div>
            <div class="main-start__item">
                <div><i class="pi pi-user text-3xl"></i></div>
                <span>{{ $t("lang.pages.common.blocks.mainStart.contactsTitle") }}</span>
                <p>{{ $t("lang.pages.common.blocks.mainStart.contactsDescription") }}</p>
                <button type="button" class="main-start__link" @click="onOpenVerbox">
                    {{ $t("lang.pages.common.blocks.mainStart.contactsButton") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Verbox from "../../mixins/Verbox";
import Button from "primevue/button";

export default {
    name: "BlockMainStart",
    mixins: [Verbox],
    data() {
        return {
            locale: window.locale,
            iconDirectoryPath: '/i/pages/main/',
        };
    },
    computed: {
        isUserAuthenticated() {
            return this.$store.getters.IS_USER_AUTHENTICATED;
        },
    },
    methods: {
        getInnerLink(page) {
            return sprintf('/%s/%s', this.locale, page);
        },
        getIconUrl(icon) {
            return this.iconDirectoryPath + icon;
        },
        onClickTrying() {
            window.open(this.getInnerLink('login'), '_self');
        }
    },
    components: {
        Button,
    }
}
</script>

<style scoped>
.main-start__container {
    padding: 0 0 75px;
    overflow: visible !important;
    z-index: 3;
    position: relative;
}
.main-start__container > p {
    font-weight: 500;
    font-size: 35px;
    color: #232D35;
    line-height: 38px;
    letter-spacing: -0.015em;
    margin-bottom: 60px;
}
.main-start__content {
    display: flex;
}
.main-start__item {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    margin: 0 12px;
    flex: 1;
    padding: 24px 24px 70px;
    box-shadow: 0 14px 66px 0 #809fa033;
    border-radius: 5px;
    position: relative;
}
.main-start__item i {
    color: rgb(112, 179, 25);
    border: 2px solid;
    border-radius: 50%;
    padding: 6px;
}
.main-start__item:first-child {
    margin-left: 0;
}
.main-start__item:last-child {
    margin-right: 0;
}
.main-start__item > * {
    margin-bottom: 12px;
}
.main-start__item > *:last-child {
    position: absolute;
    bottom: 12px;
    left: 24px;
    right: 24px;
}
.main-start__item img {
    max-width: 45px;
    width: 45px;
}
.main-start__item span {
    color: #70B319;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    display: inline-block;
}
.main-start__item p {
    display: inline-block;
}
.main-start__link {
    text-align: center;
    text-decoration: none;
    color: #fff;
    background-color: #70B319;
    padding: 10px;
    border-radius: 5px;
    font-size: 18px;
    font-weight: 500;
}
button.main-start__link {
    border: none;
    cursor: pointer;
    font-family: inherit;
}
.main-start__icons {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
}
@media(max-width: 1500px) {
    .main-start__container {
        padding: 0 15px 75px;
    }
}

@media(max-width: 991px) {
    .main-start__container {
        padding: 0 40px 75px;
    }
}

@media(max-width: 768px) {
    .main-start__content {
        flex-direction: column;
        margin: 10px 0;
    }
    .main-start__item {
        margin: 15px 0;
    }
}

@media(max-width: 480px) {
    .main-start__container {
        padding: 0 15px 10px;
    }
    .main-start__container > p {
        text-align: center;
    }
}
</style>
